import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const viewportConfig = { 
  threshold: 0.1,
  triggerOnce: false,
  rootMargin: "-50px 0px"
};

const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
      staggerChildren: 0.15,
      when: "beforeChildren"
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

const ContactDescription = () => {
  const [ref, inView] = useInView(viewportConfig);
  const controls = useAnimation();

  React.useEffect(() => {
    controls.start(inView ? "visible" : "hidden");
  }, [controls, inView]);

  return (
    <Box
      ref={ref}
      component={motion.div}
      variants={containerVariants}
      initial="hidden"
      animate={controls}
      sx={{ 
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        minHeight: '100px'
      }}
    >
      <Box
        component={motion.div}
        variants={itemVariants}
      >
        <Typography 
          variant="body1" 
          sx={{ 
            color: '#1A1A1A',
            fontSize: '1.125rem',
            lineHeight: 1.6,
            maxWidth: '600px'
          }}
        >
          Ready to find a mortgage that helps you achieve your long-term financial goals? 
          Then I'm ready to hear from you. Reach out to me now and let's find a time to discuss your needs.
        </Typography>
      </Box>
    </Box>
  );
};

export default ContactDescription; 